// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS POUR LA BARR DE RECHERCHE */

.search-bar-container {
  display: flex;
  align-items: center;
  border: none;
  padding: 0;
  border-radius: 0.5rem;
  width: 5%;
  transition: width 0.3s ease;
  color: #43CE0C;

}

.search-bar-container.focused {
  width: 30%;
  margin-right: 3%;
  border: 1px solid #43CE0C ;
  background-color: #fff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  padding: 0;
  height: 5.7vh;
}

.search-input {
  flex: 1 1;
  border: none;
  outline: none;
   background-color: transparent;
}

`, "",{"version":3,"sources":["webpack://./src/components/buttons/btn.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,qBAAqB;EACrB,SAAS;EACT,2BAA2B;EAC3B,cAAc;;AAEhB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,6CAA6C;EAC7C,UAAU;EACV,aAAa;AACf;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;GACZ,6BAA6B;AAChC","sourcesContent":["/* CSS POUR LA BARR DE RECHERCHE */\r\n\r\n.search-bar-container {\r\n  display: flex;\r\n  align-items: center;\r\n  border: none;\r\n  padding: 0;\r\n  border-radius: 0.5rem;\r\n  width: 5%;\r\n  transition: width 0.3s ease;\r\n  color: #43CE0C;\r\n\r\n}\r\n\r\n.search-bar-container.focused {\r\n  width: 30%;\r\n  margin-right: 3%;\r\n  border: 1px solid #43CE0C ;\r\n  background-color: #fff;\r\n  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);\r\n  padding: 0;\r\n  height: 5.7vh;\r\n}\r\n\r\n.search-input {\r\n  flex: 1;\r\n  border: none;\r\n  outline: none;\r\n   background-color: transparent;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
